module.exports = __webpack_public_path__ + "static/media/profile-img.ef85f9b8.jpg";